export default __webpack_public_path__ + "static/media/SOUSCRIPTION_RGB.48064270.jpg";